import axios from 'axios' 
import { CDN_URI, HBNS_APP_ID, PROJECT_ID, PROJECT_FILES_URI, PROJECT_UPLOAD_URI, PROJECT_DOCS_URI } from '../utils/appconfig.js'
import { generateTraceId } from '../utils/service_util.js'



const files_api_url = PROJECT_FILES_URI + '/' + PROJECT_ID + '/files'

// Example function to upload the file to an API endpoint
export const upload_file = async (upload_file, upload_name, access_token, onComplete, onError) => {
    
    const upload_url = files_api_url + '/upload'

    const formData = new FormData();
    formData.append("upload_file", upload_file); // 'upload_file' is the key expected by the server
    formData.append("project", PROJECT_ID); // include project identifier if required
    formData.append("replace_existing", true);
    formData.append("is_public", true);
    formData.append("is_published", true); 

    if (upload_name) {
        formData.append("upload_name", upload_name);
    }  
 
    const headers = {
        'HBNS-APP-ID': HBNS_APP_ID,
        'HBNS-TRACE-ID': generateTraceId(),
        'Authorization': `Bearer ${access_token}`
    }

    try {
        // await delay(1000); // simulate network delay for testing loading states
        const response = await axios.post(upload_url, formData, { headers })
        onComplete(response.data)
    } catch (err) {
        var authError = null
        if (err.response) {
            if (err.response.status === 401) {
                authError = "upload api request not authorized"
            } else if (err.response.status === 403) {
                authError = "upload api request forbidden"
            } else if (err.response.status && err.response.status > 200) {
                authError = `upload api returned error status ${err.response.status}`
            }
        } else {
            authError = `unexpected error in upload_file ${err.toString()}`
        }
        onError(authError)
    }

};

export const search_files = async (params, access_token, onComplete, onError) => {
    const { images_only, is_public, collection } = params;
    const headers = {
        'HBNS-APP-ID': HBNS_APP_ID,
        'HBNS-TRACE-ID': generateTraceId(),
        'Authorization': `Bearer ${access_token}`
    }

    try {
        // await delay(1000); // simulate network delay for testing loading states
        const response = await axios.get(files_api_url, params, { headers })
        onComplete(response.data)
    } catch (err) {
        var authError = null
        if (err.response) {
            if (err.response.status === 401) {
                authError = "search api request not authorized"
            } else if (err.response.status === 403) {
                authError = "search api request forbidden"
            } else if (err.response.status && err.response.status > 200) {
                authError = `search api returned error status ${err.response.status}`
            }
        } else {
            authError = `unexpected error in search files ${err.toString()}`
        }
        onError(authError)
    }
    
}

// Example function to upload the file to an API endpoint
export const upload_json_as_file = async (jsonData, filename, access_token, onComplete, onError) => {
    const api_url = PROJECT_UPLOAD_URI
    console.log('uploading json: ', jsonData)
    console.log('uploading json string: ' + JSON.stringify(jsonData))
    const headers = {
        'HBNS-APP-ID': HBNS_APP_ID,
        'HBNS-TRACE-ID': generateTraceId(),
        'Authorization': `Bearer ${access_token}`
    }


    try {
        // 1. Stringify the JSON data
        const jsonString = JSON.stringify(jsonData);

        // 2. Create a Blob with the JSON data and type
        // The filename 'data.json' can be specified in the FormData append method
        const jsonBlob = new Blob([jsonString], { type: 'application/json' });

        // 3. Create a FormData object and append the blob
        const formData = new FormData();
        // 'document' is the field name the backend expects, 'data.json' is the filename
        formData.append("upload_file", jsonBlob, filename);
        formData.append("project", PROJECT_ID); // include project identifier if required
        formData.append("replace_existing", true);
        formData.append("is_public", true);
        // formData.append("collection", "tiptapdocs");

        // 4. Send the FormData with Axios
        // Axios automatically sets the Content-Type header to multipart/form-data when you send a FormData object
        const response = await axios.post(api_url, formData, { headers })
        onComplete(response.data)

    } catch (err) {
        var authError = null
        if (err.response) {
            if (err.response.status === 401) {
                authError = "upload api request not authorized"
            } else if (err.response.status === 403) {
                authError = "upload api request forbidden"
            } else if (err.response.status && err.response.status > 200) {
                authError = `upload api returned error status ${err.response.status}`
            }
        } else {
            authError = `unexpected error in upload_file ${err.toString()}`
        }
        onError(authError)
    }
};

export const get_tiptap_test_data = async (onComplete, onError) => {

    const test_tiptap_data_url = "https://projectservice.huntercbuxton.com/files/ksb/tiptaptest.json"

    const headers = {
        'HBNS-APP-ID': HBNS_APP_ID,
        'HBNS-TRACE-ID': generateTraceId()
    } 
    try { 
        // 4. Send the FormData with Axios
        // Axios automatically sets the Content-Type header to multipart/form-data when you send a FormData object
        const response = await axios.get(test_tiptap_data_url, {
            headers: headers
        });
        onComplete(response.data)

    } catch (err) {
        var authError = null
        if (err.response) {
            if (err.response.status === 401) {
                authError = "fileserver request not authorized"
            } else if (err.response.status === 403) {
                authError = "fileserver  request forbidden"
            } else if (err.response.status && err.response.status > 200) {
                authError = `fileserver  returned error status ${err.response.status}`
            }
        } else {
            authError = `unexpected error in get_tiptap_test_data ${err.toString()}`
        }
        onError(authError)
    }
}

const docs_api_url = PROJECT_DOCS_URI + '/' + PROJECT_ID + '/docs'

export const save_tiptap_doc = async (uuid, title, jsonData, labels, is_public, is_published, linked_files, collection, access_token, onComplete, onError) => { 
    console.log('uploading json: ', jsonData)
    const request_body = { 
        uuid: uuid,
        title: title, 
        data: jsonData,
        project: PROJECT_ID,
        format: 'tiptap',
        labels: labels,
        is_public: is_public,
        is_published: is_published,
        linked_files: linked_files,
        collection: collection
    } 
    const headers = {
        'HBNS-APP-ID': HBNS_APP_ID,
        'HBNS-TRACE-ID': generateTraceId(),
        'Authorization': `Bearer ${access_token}`
    } 
    try { 
        const response = await axios.put(docs_api_url, request_body, { headers })
        onComplete(response.data)
    } catch (err) {
        var authError = null
        if (err.response) {
            if (err.response.status === 401) {
                authError = "docs api request not authorized"
            } else if (err.response.status === 403) {
                authError = "docs api request forbidden"
            } else if (err.response.status && err.response.status > 200) {
                authError = `docs api returned error status ${err.response.status}`
            }
        } else {
            authError = `unexpected error in save_tiptap_doc ${err.toString()}`
        }
        onError(authError)
    }
};


export const get_tiptap_doc = async (doc_id, access_token, onComplete, onError) => {
    const api_url = docs_api_url + '/' + doc_id //+ '/' + encodeURIComponent(PROJECT_ID) + '/' + encodeURIComponent(title)
    const headers = {
        'HBNS-APP-ID': HBNS_APP_ID,
        'HBNS-TRACE-ID': generateTraceId(),
        'Authorization': `Bearer ${access_token}`
    } 
    try {  
        const response = await axios.get(api_url, { headers: headers, params: {
      ID: 12345,
      name: 'John'
    } });
        onComplete(response.data)

    } catch (err) {
        var authError = null
        if (err.response) {
            if (err.response.status === 401) {
                authError = "docs request not authorized"
            } else if (err.response.status === 403) {
                authError = "docs  request forbidden"
            } else if (err.response.status && err.response.status > 200) {
                authError = `docs  returned error status ${err.response.status}`
            }
        } else {
            authError = `unexpected error in get_tiptap_doc ${err.toString()}`
        }
        onError(authError)
    }
}


export const build_cdn_url = (resource_type, resource_id) => {
    return CDN_URI + '/' + PROJECT_ID + '/' + resource_type + '/' + encodeURIComponent(resource_id)
}

export const build_cdn_files_url = (filename) => {
    return CDN_URI + '/' + PROJECT_ID + '/files/' + encodeURIComponent(filename)
}

export const get_cdn_doc = async (doc_id, onComplete, onError) => {
    const api_url = build_cdn_url('docs', doc_id)  
    const headers = {
        'HBNS-APP-ID': HBNS_APP_ID 
    } 
    try {  
        const response = await axios.get(api_url, { headers: headers, params: {} });
        onComplete(response.data) 
    } catch (err) {
        var authError = null
        if (err.response) {
            if (err.response.status === 401) {
                authError = "docs request not authorized"
            } else if (err.response.status === 403) {
                authError = "docs  request forbidden"
            } else if (err.response.status && err.response.status > 200) {
                authError = `docs  returned error status ${err.response.status}`
            }
        } else {
            authError = `unexpected error in get_tiptap_doc ${err.toString()}`
        }
        onError(authError)
    }
}


